/* eslint-disable @next/next/no-img-element */
"use client";
import { Fragment, useState } from "react";
import { CN_PRODUCT } from "@/utils/const";
import Image, { StaticImageData } from "next/image";
import { currency } from "./const";
import FLASH_SALE_ICON from "@/images/icon/flash-sale.png";
import ScoreRating from "@/components/customerReviews/scoreRating";
import SkuCoupon from "./skuCoupon";
import SelectModelGroup from "./selectModelGroup";
import BuyOrAddToCar from "./buyOrAddToCart";
import Assurance from "@/components/product/assurance";
import { JDIPrice } from "@/lib/jdiClientUtils";
import { IntlDialog } from "@/components/intlMui";
import { getInitCommentListPage } from "@/apis/service";
import AllCommentList from "@/components/customerReviews/allCommentList";
import ArrowIcon from "@/images/icon/arrow-default.svg";
import KlranaIcon from "@/images/icon/product-klrana.svg";
import { SkuDetailWrapper } from "@/styles/product";
import { ErrorBoundary } from "react-error-boundary";
import { useParams } from "next/navigation";
import KlranaDialog from "./klranaDialog";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
import { useTranslation } from "@/i18n/client";
// styles

interface SkuDetailProps {
  floors: any;
}

export default function SkuDetail(props: SkuDetailProps) {
  const { t } = useTranslation();
  const floors = props.floors;
  const title = floors.productSkuNameFloor?.data["C-M#ViewTitleItem&core"]?.title;
  const productCommentSaleFloor = floors?.productCommentSaleFloor?.data;
  const productPriceFloor = floors?.productPriceFloor?.data;
  const productPromotionFloor = floors?.productPromotionFloor?.data;
  const productCouponFloor = floors?.productCouponFloor?.data;
  const { star, commentCount, starShow, saleAmount } = productCommentSaleFloor || {};
  const { percentReductionDesc, mainPrice, crossOffPrice }: Record<string, string> = productPriceFloor?.["C-M#priceViewItem&priceInfo"] || {};
  // 排行榜数据
  const bestSellerFloor = floors?.productBestSellerFloor?.data;
  const rankText = bestSellerFloor?.rankText;
  const category = bestSellerFloor?.categoryName;
  const categoryPageUrl = bestSellerFloor?.destinationPageUrl;
  // 分期支付
  const productPaymentFloor = floors?.productPaymentFloor?.data;
  const payText = productPaymentFloor?.payText;
  const klranaContent = productPaymentFloor?.popUpText;

  const [allCommentInfo, setAllCommentInfo] = useState<any>();
  const { sku: skuId } = useParams<{ sku: string }>();
  const [open, setOpen] = useState<boolean>(false);
  const [openKlrana, setOpenKlrana] = useState<boolean>(false);

  const openReviewListDialog = async () => {
    sendClickTrack.Productdetail_StarRating_Click({
      mainskuid: skuId,
      ratingNum: String(star),
      reviewsNum: String(commentCount),
      SalesNum: String(saleAmount),
    });
    const res = await getInitCommentListPage({ skuId });
    if (res.code === "200") {
      setAllCommentInfo(res?.data);
    }
    setOpen(true);
  };

  const closeReviewListDialog = () => {
    setOpen(false);
  };

  const gotoRankLandpage = () => {
    location.href = categoryPageUrl;
  };

  const openKlranaDialog = (displayText: string) => {
    setOpenKlrana(true);
    sendClickTrack.Productdetail_Installment_Click({
      mainskuid: skuId,
      displayText,
    });
  };

  const getReviewsDesc = () => {
    return commentCount == "1" ? `${t("dp.commentCount.review", { count: 1 })}` : `${t("dp.commentCount.review", { count: 5 })}`;
  };

  return (
    <SkuDetailWrapper>
      {!!title && <div className={CN_PRODUCT("sku-auxiliary-info")}>{title}</div>}
      <ErrorBoundary fallback={null}>
        {(bestSellerFloor || commentCount || saleAmount) && (
          <div className={CN_PRODUCT("sku-auxiliary-info")}>
            {bestSellerFloor && (
              <div className={CN_PRODUCT("sku-best-seller")}>
                <span className="rank-text">{rankText}</span>
                <span className="catelogy-text" onClick={gotoRankLandpage}>
                  {t("dp.in")} {category}
                </span>
                <ArrowIcon />
              </div>
            )}
            {productCommentSaleFloor && commentCount && (
              <div
                className={CN_PRODUCT("sku-score")}
                exptag={"exp|" + EXPOSURE_RECORD.Productdetail_StarRating_Expo}
                data-exptag-config={dataExpTagConfig}
                data-exptag-json-param={JSON.stringify({
                  mainskuid: skuId,
                  ratingNum: String(star),
                  reviewsNum: String(commentCount),
                  SalesNum: String(saleAmount),
                })}
              >
                <ScoreRating
                  starShow={starShow}
                  value={star}
                  extra={
                    saleAmount ? (
                      <>
                        <span className="sale-amount margin-left">{t("dp.itemSold", { saleAmount })}</span>
                        <span className="comment-count" onClick={openReviewListDialog}>
                          {commentCount} {getReviewsDesc()}
                          <ArrowIcon />
                        </span>
                      </>
                    ) : (
                      <span className="comment-count">
                        {commentCount} {getReviewsDesc()}
                        <ArrowIcon />
                      </span>
                    )
                  }
                />
              </div>
            )}
            {productCommentSaleFloor && !commentCount && saleAmount && (
              <div className={CN_PRODUCT("sku-score")}>
                <div className="sale-amount">{t("dp.itemSold", { saleAmount })}</div>
              </div>
            )}
            <IntlDialog
              onClose={closeReviewListDialog}
              aria-labelledby="customized-dialog-title"
              open={open}
              title="Reviews"
              content={<AllCommentList data={allCommentInfo} skuId={skuId} />}
              width={800}
              showButtonAction={false}
            />
          </div>
        )}
      </ErrorBoundary>

      {/* {价格} */}
      {mainPrice && (
        <div className={CN_PRODUCT("sku-price")}>
          <div className={CN_PRODUCT("sku-price-real")}>
            <JDIPrice
              symbol={currency}
              price={mainPrice}
              uiType={1}
              integerStyle={{ fontSize: "32px" }}
              containerStyle={{ fontSize: "20px", lineHeight: "20px" }}
            />
          </div>
          {percentReductionDesc && (
            <>
              <div className={CN_PRODUCT("sku-price-origin")}>
                <JDIPrice symbol={currency} price={crossOffPrice} uiType={2} lineThrough containerStyle={{ fontSize: "18px", lineHeight: "20px" }} />
              </div>
              <div className={CN_PRODUCT("sku-price-tag")}>{percentReductionDesc}</div>
            </>
          )}
        </div>
      )}

      {/* {分期支付} */}
      {productPaymentFloor && (
        <div
          className={CN_PRODUCT("sku-klrana")}
          onClick={() => openKlranaDialog(payText)}
          exptag={"exp|" + EXPOSURE_RECORD.Productdetail_Installment_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({ mainskuid: skuId, displayText: payText })}
        >
          <span dangerouslySetInnerHTML={{ __html: payText }} />
          <KlranaIcon />
        </div>
      )}
      <KlranaDialog open={openKlrana} closeFn={() => setOpenKlrana(false)} content={klranaContent} />

      {/* {优惠券 活动} */}
      <SkuCoupon floors={floors} skuId={skuId} />

      <ErrorBoundary fallback={null}>
        <SelectModelGroup floors={floors} spuTitle={title} />
      </ErrorBoundary>
      <BuyOrAddToCar floors={floors} />
      <Assurance floors={floors} skuId={skuId} />
    </SkuDetailWrapper>
  );
}
